import { isInstallerPartner } from './partnerTypes';

export interface InstallerPartnerRow {
  id: string;
  company_name: string | null;
  city: string | null;
  state: string | null;
  is_active: boolean | null;
  partner_type?: string | null;
}

export interface InstallerPartnerOption {
  id: string;
  name: string;
  location: string;
}

/**
 * The companies a project's "Installation Partner" can be set to: active installer-type partners
 * (never an EPC), sorted by name, filtered by name or city. The currently assigned one stays listed
 * even if it has since been deactivated, so the panel can still show it as selected.
 */
export function installerPartnerOptions(
  rows: InstallerPartnerRow[],
  search: string,
  currentId: string | null
): InstallerPartnerOption[] {
  const q = search.trim().toLowerCase();
  return rows
    .filter((r) => isInstallerPartner(r) && (r.is_active !== false || r.id === currentId))
    .map((r) => ({
      id: r.id,
      name: r.company_name || 'Unnamed company',
      location: [r.city, r.state].filter(Boolean).join(', '),
    }))
    .filter((o) => !q || o.name.toLowerCase().includes(q) || o.location.toLowerCase().includes(q))
    .sort((a, b) => a.name.localeCompare(b.name));
}
